/* eslint react/prop-types: 0 */
import React from 'react';
import Svg from 'rp-react-svg-icon';
import RatioCell from '../../shared/cells/RatioCell';
import { HorseLink } from '../../shared/links/ProfileLink';
import { formatMoney } from '../../utils/money';

const columns = onClick => [
    {
        key: 'arrow',
        header: ' ',
        cell: ({ horseUid, descendants }) => (
            descendants ? (
                <button
                    className="hp-nicks__expand"
                    onClick={() => onClick(horseUid)}
                >
                    <Svg className="hp-nicks__arrow tableShowIcon" iconName="down" size="Medium" />
                </button>
            ) : null
        ),
    },
    {
        key: 'styleName',
        header: "dam's sire",
        cell: ({ styleName, horseUid }) => (
            <HorseLink
                horseStyleName={styleName}
                horseUid={horseUid}
            />
        ),
        sortFn: 'alphabetic',
    },
    {
        key: 'winners',
        header: 'winners / runners',
        cell: ({ winners: a, runners: b }) => <RatioCell a={a} b={b} />,
    },
    {
        key: 'winnersPercent',
        header: '%',
    },
    {
        key: 'wins',
        header: 'wins / runs',
        cell: ({ wins: a, runs: b }) => <RatioCell a={a} b={b} />,
    },
    {
        key: 'winsPercent',
        header: '%',
    },
    {
        key: 'winPrizeMoney',
        header: 'winnings',
        cell: ({ winPrizeMoney }) => formatMoney(winPrizeMoney),
    },
    {
        key: 'totalMoney',
        header: 'total earnings',
        cell: ({ totalMoney }) => formatMoney(totalMoney),
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/horse/nicks/columns.jsx